import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';

const styles = theme => ({
    rowIconButtonRoot: {
        height: 40
    }
});

class StepComponent extends React.Component {
    render() {        
        const { step, columns, colSpan } = this.props;        
        return (
            <React.Fragment>
                <TableRow selected>
                    <TableCell className="icon-cell"><TrendingFlatIcon /></TableCell>
                    {
                        columns &&
                        [].concat(columns).map((col, colIndex) => {
                            return(<TableCell colSpan={colSpan} key={`table_row_${step.queryId}_cell_${colIndex}`}>{col.field === "queryId" ? `Step ${step[col.field]}` : step[col.field]}</TableCell>)
                        })
                    }
                    {
                        <TableCell numeric></TableCell>
                    }
                </TableRow>
            </React.Fragment>
        );
    }
}

StepComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired
}

export default withStyles(styles)(StepComponent);


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/ExecutionHistory/StepComponent.js